/**
 * Mindrail logo.
 *
 *   <MindrailLogo />                     → official PNG lockup (mark + wordmark)
 *   <MindrailLogo variant="png-mark" />  → official PNG mark only (for tiny contexts)
 *   <MindrailLogo variant="mark" />      → SVG archway mark (vector fallback)
 *
 * The `size` prop controls the rendered height; width auto-scales to keep aspect.
 */
export default function MindrailLogo({
  variant = "full",
  size = 28,
  className = "",
}) {
  if (variant === "mark") {
    return <MindrailMark size={size} className={className} />;
  }

  if (variant === "png-mark") {
    return (
      <span
        data-testid="mindrail-logo"
        className={`inline-flex items-center ${className}`}
      >
        <img
          src="/mindrail-mark.png"
          alt="Mindrail"
          style={{ height: size, width: "auto", display: "block" }}
          draggable={false}
        />
      </span>
    );
  }

  // Default → official full lockup PNG
  return (
    <span
      data-testid="mindrail-logo"
      className={`inline-flex items-center ${className}`}
    >
      <img
        src="/mindrail-logo.png"
        alt="Mindrail"
        style={{ height: size, width: "auto", display: "block" }}
        draggable={false}
      />
    </span>
  );
}

export function MindrailMark({ size = 24, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden
    >
      <defs>
        <linearGradient
          id="mr-mark-grad"
          x1="60"
          y1="6"
          x2="8"
          y2="62"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0%" stopColor="#93C5FD" />
          <stop offset="50%" stopColor="#3B82F6" />
          <stop offset="100%" stopColor="#1E40AF" />
        </linearGradient>
        <linearGradient
          id="mr-mark-ladder"
          x1="20"
          y1="60"
          x2="32"
          y2="28"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0%" stopColor="#1d4ed8" />
          <stop offset="100%" stopColor="#60A5FA" />
        </linearGradient>
      </defs>
      <path
        d="M 8 60 V 30 A 24 24 0 0 1 56 30 V 60 H 42 V 30 A 10 10 0 0 0 22 30 V 60 Z"
        fill="url(#mr-mark-grad)"
      />
      <path
        d="M 50 30 V 60 H 52 V 30 A 20 20 0 0 0 32 10 V 12 A 18 18 0 0 1 50 30 Z"
        fill="white"
        opacity="0.18"
      />
      <g
        stroke="url(#mr-mark-ladder)"
        strokeWidth="1.6"
        strokeLinecap="round"
        fill="none"
      >
        <line x1="18" y1="60" x2="26" y2="32" />
        <line x1="28" y1="60" x2="30" y2="32" />
        <line x1="19" y1="56" x2="27.5" y2="56" />
        <line x1="20" y1="51" x2="28" y2="51" />
        <line x1="21" y1="46" x2="28.5" y2="46" />
        <line x1="22" y1="41" x2="29" y2="41" />
        <line x1="23" y1="36" x2="29.5" y2="36" />
      </g>
    </svg>
  );
}
